const STATUS_STYLES = {
  New:         { background: '#E6F1FB', color: '#0C447C' },
  Qualified:   { background: '#EAF3DE', color: '#27500A' },
  Proposal:    { background: '#FAEEDA', color: '#633806' },
  Negotiation: { background: '#EEEDFE', color: '#3C3489' },
  'Closed Lost': { background: '#FCEBEB', color: '#791F1F' },
  Cold:        { background: '#F1EFE8', color: '#444441' },
}

export default function StatusBadge({ status }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES['Cold']
  return (
    <span style={{ ...styles.base, ...style }}>
      {status}
    </span>
  )
}

const styles = {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 11,
    fontWeight: 500,
    padding: '2px 8px',
    borderRadius: 20,
    whiteSpace: 'nowrap',
  },
}
